const Copy = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.5 5A1.5 1.5 0 0 0 10 6.5a.5.5 0 0 1-1 0A2.5 2.5 0 0 1 11.5 4h6A2.5 2.5 0 0 1 20 6.5v6a2.5 2.5 0 0 1-2.5 2.5.5.5 0 0 1 0-1 1.5 1.5 0 0 0 1.5-1.5v-6A1.5 1.5 0 0 0 17.5 5zM4 11.5A2.5 2.5 0 0 1 6.5 9h6a2.5 2.5 0 0 1 2.5 2.5v6a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 4 17.5zM6.5 10A1.5 1.5 0 0 0 5 11.5v6A1.5 1.5 0 0 0 6.5 19h6a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0-1.5-1.5z"
      clipRule="evenodd"
    />
  </>
)
export default Copy
